import { render } from "./TalentInfoScreen.vue?vue&type=template&id=4aedbd14&ts=true&lang=pug"
import script from "./TalentInfoScreen.vue?vue&type=script&lang=ts"
export * from "./TalentInfoScreen.vue?vue&type=script&lang=ts"

import "./TalentInfoScreen.vue?vue&type=style&index=0&id=4aedbd14&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__